/**
 *
 */
const setupPainAreas = () =>
{
	const accordionItems      = document.querySelectorAll( '#pain-accordion .accordion-item' );
	const swapImage           = document.querySelector( '.diagram-images img.right' );
	const swapImageDefaultSrc = swapImage ? swapImage.src : '';


	accordionItems.forEach( item =>
	{
		item.addEventListener( 'click', () =>
		{
			const button   = item.querySelector( '.accordion-button' );
			const isOpen   = button.getAttribute( 'aria-expanded' ) === 'true';
			const imageSrc = button.dataset.image;

			if (isOpen) {
				swapImage.src = imageSrc;
			} else {
				swapImage.src = swapImageDefaultSrc;
			}
		} );
	} );
};


/**
 *
 */
export default setupPainAreas;

